import {
  OrderItemUpdateRequestType,
  OrderItemUpdateResponseType,
} from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useOrderItemUpdate = (orderItemId: number) => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: (data: OrderItemUpdateRequestType) =>
      apiV2Request({
        user,
        business,
        method: "put",
        path: `order-items/${orderItemId}`,
        data,
      }).then(
        (data) => apiV2AssertResponse(data).data as OrderItemUpdateResponseType,
      ),

    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: [business?.id, ServerStateKeys.OrderItems, orderItemId],
      });
      queryClient.invalidateQueries({
        queryKey: [business?.id, ServerStateKeys.OrderItems],
      });
      queryClient.invalidateQueries({
        queryKey: [business?.id, ServerStateKeys.OrdersLegacy],
      });
      queryClient.invalidateQueries({
        queryKey: [user?.uid, business?.id, ServerStateKeys.Orders],
      });
    },
  });
};
